import { forwardRef, useState } from 'react'

// icons
import { ReactComponent as UploadIcon } from '../../assets/icons/upload.svg'

// styles
import styles from './input-file.module.scss'

type InputFileProps = {
	readonly className?: string
	readonly maxFileSize?: string
} & React.InputHTMLAttributes<HTMLInputElement>

const InputFile = forwardRef(
	(
		props: InputFileProps,
		ref: React.ForwardedRef<HTMLInputElement>
	): JSX.Element => {
		const { className, maxFileSize, ...attr } = props
		// const inputRef = useRef<HTMLInputElement | null>(null)
		const [fileName, setFileName] = useState<string | undefined>()

		return (
			<div className={[styles.inputFile, className].join(' ').trim()}>
				<div className={styles.placeholder}>
					<div className={styles.instructions}>
						<UploadIcon className={styles.instructionsIcon} />
						{fileName ? (
							<span>
								Upload <u>{fileName}</u> or{' '}
								<u>Choose another file</u>
							</span>
						) : (
							<span>
								Drag and Drop file here or <u>Choose a file</u>
							</span>
						)}
					</div>
					<input
						ref={ref}
						{...attr}
						type="file"
						title={
							fileName
								? `Upload ${fileName} or Choose another file`
								: 'Drag and Drop file here or Choose a file'
						}
						onChange={(e) => {
							setFileName(
								e.currentTarget.value.split(/(\\|\/)/g).pop()
							)
							attr.onChange?.(e)
						}}
					/>
				</div>

				{(attr.accept || maxFileSize) && (
					<div className={styles.footer}>
						{attr.accept && (
							<p className={styles.supportedFormats}>
								Supported formats:{' '}
								{attr.accept
									.toUpperCase()
									.replace(/\./g, '')
									.replace(/\s/g, '')
									.replace(/,/g, ', ')}
							</p>
						)}
						{maxFileSize && (
							<p className={styles.maxFileSize}>
								Maximum file size: {maxFileSize}
							</p>
						)}
					</div>
				)}
			</div>
		)
	}
)

export default InputFile
